module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "18.d8543523.webp";